import NavBar from './components/NavBar';
import Home from './components/Home';
import {Helmet} from "react-helmet";
import About from './components/About';
import Wid from './components/Wid';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import 'animate.css';
function App() {


  useEffect(()=>{
    Aos.init();
  },[])

  return (
   
    <>
    <Helmet>
    <meta charSet="utf-8" />
<title>Krishna Bansal | Full Stack Developer | krishna-web.vercel.app</title>
<link rel="canonical" href="https://krishna-web.vercel.app" />
 
<meta name="title" content="Krishna Bansal | Full Stack Developer" />
<meta name="description" content="Hi, I'm Krishna Bansal — a passionate Full Stack Software Developer 🚀 specializing in React.js, Node.js, and modern web technologies. Explore my portfolio, skills, and projects." />
 
<meta property="og:type" content="website" />
<meta property="og:url" content="https://krishna-web.vercel.app" />
<meta property="og:title" content="Krishna Bansal | Full Stack Developer" />
<meta property="og:description" content="Portfolio of Krishna Bansal — React Developer | Python Developer | Software Engineer. Discover my work, experience, and web development projects." />
<meta property="og:image" content="https://krishna-web.vercel.app/preview.jpg" />
 
<meta property="twitter:card" content="summary_large_image" />
<meta property="twitter:url" content="https://krishna-web.vercel.app" />
<meta property="twitter:title" content="Krishna Bansal | Full Stack Developer" />
<meta property="twitter:description" content="Explore the portfolio of Krishna Bansal — Full Stack Developer, Web Enthusiast, and passionate tech builder with experience in modern web stacks." /> 



                 <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.6/dist/umd/popper.min.js" integrity="sha384-oBqDVmMz9ATKxIep9tiCxS/Z9fNfEXiDAYTujMAeBAsjFuCZSmKbSSUnQlmh/jp3" crossorigin="anonymous"></script>
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.min.js" integrity="sha384-mQ93GR66B00ZXjt0YO5KlohRA5SY2XofN4zfuZxLkoj1gXtW8ANNCe9d5Y3eG5eD" crossorigin="anonymous"></script>
<script src="https://kit.fontawesome.com/27a6464a6f.js" crossorigin="anonymous"></script>
            </Helmet>
    <div className="header">
        <NavBar/>
    </div>
    <div id="home" className="overflow-hidden">
        <Home/>
    </div>
    <div id="about" className="overflow-hidden">
      <About/>
    </div>
    <div id="wid" className="overflow-hidden">
      <Wid/>
    </div>
    <div id="skills" className="overflow-hidden">
      <Skills/>
    </div>
    <div id="experience" className="overflow-hidden">
      <Experience/>
    </div>
    <div id="projects" className="overflow-hidden">
      <Projects/>
    </div>
    <div id="gallery" className="overflow-hidden">
      <Portfolio/>
    </div>
    <div id="contact" className="overflow-hidden">
      <Contact/>
    </div>
    <div className="footer" className="overflow-hidden">
      <Footer/>
    </div>
    </>
  );
}

export default App;
